import React, { useState, useEffect, useMemo } from "react";
import "./dialog-pdf-by-volume.pure.css";
import { Dialog } from "@progress/kendo-react-dialogs";
import { SimpleLoading } from "../../pures";
import PdfReader from '../../pures/adobePfdReader/PdfReader'

const DialogPdfByVolumePure = (props) => {
  const [currentBase64File, setCurrentBase64File] = useState("");
  const { loadingComponent, cancel, title, pdfFiles, dataItem } = props;

  const pdf = useMemo(() => <PdfReader className="pdfReader" file={currentBase64File} isFile src={`data:application/pdf;base64,${currentBase64File}`} ></ PdfReader>, [currentBase64File])

  let dialogCollaboratorWidth = loadingComponent ? 590 : 700;
  let dialogCollaboratorHeight = loadingComponent ? 430 : 650;

  const transformFileToBase64 = (dataItem) => {
    const currentFile = Object.values(pdfFiles).find(
      (file) => file.name === dataItem.fileName
    );

    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (currentFile) =>
        resolve(currentFile.target.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(currentFile);
    }).then((res) => {
      setCurrentBase64File(res);
    });
  };

  useEffect(() => {
    transformFileToBase64(dataItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataItem]);

  return (
    <Dialog
      width={dialogCollaboratorWidth}
      height={dialogCollaboratorHeight}
      className="dialog-container"
      title={title}
      onClose={cancel}
    >
      {loadingComponent && (
        <div>
          <SimpleLoading />
        </div>
      )}
      <div className="body-dialog">
        {pdf}
        {/* <PdfReader file={currentBase64File} isFile
          src={
            currentBase64File
              ? "data:application/pdf;base64," + currentBase64File + "#toolbar=0"
              : null
          } /> */}
      </div>
    </Dialog>
  );
};

export default DialogPdfByVolumePure;
